import type {
  UserPropertyFeedToManualStatusesCountWebDto,
  UserPropertyFeedToManualStatusesStatusDetailsWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

const ConversionCount = ({
  total = 0,
  pending = 0,
  processing = 0,
  failed = 0,
  succeeded = 0,
}: Partial<UserPropertyFeedToManualStatusesCountWebDto> = {}) => ({
  total: Number(total),
  pending: Number(pending),
  processing: Number(processing),
  failed: Number(failed),
  succeeded: Number(succeeded),
});

const Status = ({
  feedListingAlias = '',
  manualListingAlias = '',
  dateCreatedTimestamp = 0,
  dateUpdatedTimestamp = 0,
  status = '',
}: Partial<UserPropertyFeedToManualStatusesStatusDetailsWebDto> = {}) => ({
  feedListingAlias: String(feedListingAlias),
  manualListingAlias: String(manualListingAlias),
  dateCreatedTimestamp: Number(dateCreatedTimestamp),
  dateUpdatedTimestamp: Number(dateUpdatedTimestamp),
  status: String(status),
});

// Deep-partial of UserPropertyFeedToManualStatusesResponseWebDto — needed because
// ListingConversion() is called with no args for initial reducer state.
type ListingConversionParam = {
  statuses?: Array<Partial<UserPropertyFeedToManualStatusesStatusDetailsWebDto>>;
  count?: Partial<UserPropertyFeedToManualStatusesCountWebDto>;
};

const ListingConversion = ({ statuses = [], count = {} }: ListingConversionParam = {}) => ({
  statuses: statuses.map(Status),
  count: ConversionCount(count),
});

export default ListingConversion;

export type ListingConversionProps = ReturnType<typeof ListingConversion>;
